var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipantVideoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_videocam_off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35,10.8333333 L28.3333333,17.5 L28.3333333,11.6666667 C28.3333333,10.75 27.5833333,10 26.6666667,10 L16.3666667,10 L35,28.6333333 L35,10.8333333 L35,10.8333333 Z M5.45,3.33333333 L3.33333333,5.45 L7.88333333,10 L6.66666667,10 C5.75,10 5,10.75 5,11.6666667 L5,28.3333333 C5,29.25 5.75,30 6.66666667,30 L26.6666667,30 C27.0166667,30 27.3166667,29.8666667 27.5666667,29.7 L32.8833333,35 L35,32.8833333 L5.45,3.33333333 L5.45,3.33333333 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 83.3333333,
    height: 83.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 83.3333333,
    height: 83.3333333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v1-Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Video-Patient-Profile-page-:-Consult-Expanded-In-Conference-Patient-Both-Muted",
    transform: "translate(-1294.000000, -156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_videocam_off",
    transform: "translate(1291.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Red,-End-Call",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.666667, -21.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "White",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "White-Copy",
    stroke: "none",
    fill: "#E82121",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantVideoOff);
export default __webpack_public_path__ + "static/media/participantVideoOff.0679a3728dd98f8fc985ca6f3a0aada3.svg";
export { ForwardRef as ReactComponent };